import { Button, Grid, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { diasDeSemanaUtil } from '../../../../../helpers';
import { useNotification } from '../../../../../helpers/Notification';
import BotonComponent from '../../../../dashboard/components/BotonNuevo';
import { asignarDiasClasesDocentesAction } from '../../DocentesAction';

const DiasClasesDocentesComponent = () => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const docentesStore = Redux.useSelector((state) => state.docentes);

  const [selectedDays, setSelectedDays] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    setSelectedDays(docentesStore.activo.diasClases?.dias ?? []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleToggle(dia) {
    if (selectedDays.includes(dia.dia)) {
      setSelectedDays(selectedDays.filter((d) => d !== dia.dia));
    } else {
      setSelectedDays([...selectedDays, dia.dia]);
    }
  }

  return (
    <Grid container spacing={2}>
      <Grid item md={12}>
        <Typography variant="body1" color="initial">
          Seleccione los días de clases
        </Typography>
        {diasDeSemanaUtil.map((dia, i) => (
          <Button
            key={i}
            variant={selectedDays.includes(dia.dia) ? 'contained' : 'outlined'}
            sx={{ mr: 1 }}
            onClick={() => handleToggle(dia)}
          >
            {selectedDays.includes(dia.dia) ? dia.dia : dia.abrev}
          </Button>
        ))}
      </Grid>
      <Grid item md={12} align="center">
        <BotonComponent
          click={async () => {
            setLoading(true);
            await asignarDiasClasesDocentesAction(
              { dispatch, notify },
              {
                idDocente: docentesStore.activo.id,
                dias: selectedDays,
              },
            );
            setLoading(false);
          }}
          disabled={selectedDays.length === 0}
          text="ASIGNAR"
          green
          loading={loading}
          saveIcon
          mr={2}
        />
      </Grid>
    </Grid>
  );
};

export default DiasClasesDocentesComponent;
